import React from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreateWorkingHours } from 'src/features/workingHours/api/useCreateWorkingHours';
import { LIST_WORKING_HOURS_RESOURCE } from 'src/features/workingHours/api/useListWorkingHours';
import WorkingHoursFormModal from 'src/features/workingHours/components/form/WorkingHoursFormModal';
import { WorkingHours } from 'src/features/workingHours/utils/types';
import { workingHoursMessages } from 'src/features/workingHours/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { useParking } from 'src/providers/ParkingProvider';

interface WorkingHoursFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedWorkingHours?: WorkingHours;
    children?: React.ReactNode;
}

function CreateWorkingHoursFormModal<TData>({ className, semantics }: WorkingHoursFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { siteId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateWorkingHours({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_WORKING_HOURS_RESOURCE] });
            toast({
                title: formatMessage(workingHoursMessages.createWorkingHoursSuccess),
                description: formatMessage(workingHoursMessages.createWorkingHoursSuccessDescription),
            });
        },
    });

    return (
        <WorkingHoursFormModal
            className={className}
            mutate={(data, onSuccess, onError) => mutate({ ...data, siteId, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={faPlus}
            isPending={isPending}
            subtitle={formatMessage(workingHoursMessages.addWorkingHoursSubtitle)}
        />
    );
}

export default CreateWorkingHoursFormModal;
